import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import { Provider } from 'react-redux';
import { LegacyUserActions } from 'vn-legacy-user';

import registerServiceWorker from './registerServiceWorker';
import store from "./store";

if (window.parent) {
    const message = LegacyUserActions.readyToReceiveData();
    window.parent.postMessage(message, '*');
}

window.addEventListener('message', function(event) {
    if (event.data.type === LegacyUserActions.INJECT_SESSIONS && event.data.payload){
        renderApp(event.data.payload);
    }
})

function renderApp(initialData) {
    ReactDOM.render(
        <Provider store={store}>
            <App initialData={initialData}/>
        </Provider>,
        document.getElementById('root')
    );
}
let mockData;

mockData = {
    sessions: {},
    permissions: {}
};

renderApp(mockData);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js